import React from "react";

import { Box, Typography } from "@mui/material";
import { Bar, BarChart, Cell, ResponsiveContainer, XAxis, YAxis } from "recharts";
import { postfixes } from "root/utils";
import { tickFormatter } from "root/utils/charts";

import ScrollableChartWrapper from "root/components/Chart/hocs/ScrollableChartWrapper";

import { numberWithSpaces } from "root/js/utils";

// --------------------------------------------------------------------------------------------------------
const VerticalBarWithDotLines = ({ data = [], isLoading, isDataNotLoaded }) => {
  return (
    <ScrollableChartWrapper {...{ isLoading, isDataNotLoaded }}>
      <ResponsiveContainer width="100%" height={500}>
        <BarChart layout="vertical" data={data}>
          <XAxis
            dataKey={"value"}
            type="number"
            height={50}
            tickFormatter={v => tickFormatter(Math.round(v), postfixes.rub)}
            stroke="#ccc"
            strokeWidth={1}
          />
          <YAxis
            dataKey={"title"}
            yAxisId={0}
            type="category"
            axisLine={false}
            tickLine={false}
            orientation="left"
            tick={<CustomYAxisTick width={110} />}
            width={120}
          />
          <YAxis
            dataKey={"value"}
            yAxisId={1}
            type="category"
            orientation="right"
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#798097" }}
            width={90}
            tickFormatter={v => numberWithSpaces(v, 0) + postfixes.rub}
          />
          <Bar
            dataKey={"value"}
            barSize={30}
            isAnimationActive={false}
            yAxisId={0}
            shape={CustomBarWithLine}>
            {data.map(item => (
              <Cell key={item.id} fill={item.value > 0 ? "#FF6B6B" : "#4CAF50"} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </ScrollableChartWrapper>
  );
};

// -----------------------------------------------------------------------------------
const CustomYAxisTick = ({ x, y, payload, width }) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <foreignObject x={-width} y={-8} width={width} height={50}>
        <Box width={width} display={"flex"} alignItems={"center"}>
          <Typography sx={{ wordWrap: "break-word" }} fontSize={"14px"} lineHeight={"14px"}>
            {payload.value}
          </Typography>
        </Box>
      </foreignObject>
    </g>
  );
};
// ------------------------------------------------------------------------------------------------------------
const CustomBarWithLine = props => {
  const { x, y, width, height, fill, value, background } = props;

  const chartMinX = background?.x;
  const chartMaxX = background?.x + background?.width;

  // Для прямоугольника: x всегда левый край, width всегда положительный
  const rectX = value >= 0 ? x : x + width;
  const rectWidth = Math.abs(width);

  // Для линии: начинаем всегда от конца бара — даже у отрицательных
  const lineStartX = value >= 0 ? x + width : x;
  const lineEndX = chartMaxX;

  return (
    <g>
      <rect x={rectX} y={y} width={rectWidth} height={height} fill={fill} />
      <line
        x1={lineStartX}
        y1={y + height / 2}
        x2={lineEndX}
        y2={y + height / 2}
        stroke="#ccc"
        strokeWidth={1}
        strokeDasharray={2}
      />
    </g>
  );
};

export default VerticalBarWithDotLines;
